/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * DashboardBody Page
 * --------------
 * Reads user information from Storage
 * Extracts display name
 * Renders a greeting and three CountCard components
 * CountCard components are reusable and responsible for
 * fetching and displaying their own stats based on the stat_type prop.
 */

import React, { useState } from 'react';
import CountCard from '../components/CountCard';
import { retrieve } from "../utils/storageHelper";
function DashboardBody() {
  let firstName =  null;
  let userName = null;

const userDataDict = retrieve('userData');

  if (userDataDict) {
    firstName = userDataDict.first_name;
    userName = userDataDict.user_name;  
  } else {
    console.warn("userData is missing or invalid in Storage");
  }

  const displayName = firstName || userName || "User";

  return (
    <div className="row g-4 mb-4">
      <div>
        <h2>Hello, {displayName}</h2>
        <span>Dashboard page provides a high level statistics of your application</span>
        <hr />
      </div>
      <div className="col-sm-6 col-md-4">
        <CountCard
          icon="bi-stack"
          label="Total Applications"
          stat_type="applications"
        />
      </div>
      <div className="col-sm-6 col-md-4">
        <CountCard
          icon="bi-person"
          label="Total Users"
          stat_type="users"
          color="#e85d04"
        />
      </div>
      <div className="col-sm-6 col-md-4">
        <CountCard
          icon="bi-table"
          label="Total Tables"
          stat_type="tables"
          color="#219ebc"
        />
      </div>
    </div>
  );
}

export default DashboardBody;
